module.exports = __webpack_public_path__ + "img/des_guzheng_3.92ce2597.jpg";